/*======================================================================================================================
  * Bluebell: src/app/state/file-exchange/file-exchange.selectors.ts
  * Last Edited: 21/02/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFileExchange from '@state/file-exchange/file-exchange.reducer';

export const selectFileExchangeState = createFeatureSelector<fromFileExchange.State>(fromFileExchange.featureKey);

export const selectFileExchangeData = createSelector(
  selectFileExchangeState,
  fromFileExchange.getFiles
);

export const selectFileExchangeSpace = createSelector(
  selectFileExchangeState,
  fromFileExchange.getSpace
);

export const selectFileExchangesLoaded = createSelector(
  selectFileExchangeState,
  fromFileExchange.getLoaded
);

export const selectFileExchangesLoading = createSelector(
  selectFileExchangeState,
  fromFileExchange.getLoading
);
